import React, { Component } from 'react';
import EnterpriseSettings from './EnterpriseSettings/EnterpriseSettings';
import ManageOffices from './ManageOffices';
import {Modal,ModalBody,Input,Button} from 'reactstrap';
import './EnterpriseInformation.css';
import axios from './../../axios';
import * as  url from './../../utils/url';
import * as actionCreators from './../../modules/actions/index';
import {connect} from 'react-redux';
import merge from 'lodash/merge';
import sortBy from 'lodash/sortBy';
import unionBy from 'lodash/unionBy'
import findIndex from 'lodash/findIndex';
import {getFlatDataFromTree} from 'react-sortable-tree';
import { isTrivvyUrl } from '../../utils/constants';
import './account-settings-bwai.css';

class EnterpriseInformation extends Component {
  constructor(props) {
    super(props);

    this.state = { 
      selectedTab : 1,
      existingMapping : null,
      allOffices : [],
      industriesList : [],
      allOfficesWithInvitations : [],
      searchedTerm : "",
      sortType : 'a-z',
    }
}
  

  componentDidMount() {
    const {organizationId} = this.props.user.profile;
    const {staticHierarchy} = organizationId;
    const {existingMapping} = this.state;
    if(!existingMapping) {
        axios.get(url.getExistingMappings(organizationId._id)).then(({data,err}) => {
              const payload = data.data;
              const {mapping} = payload;
              this.setState({
                existingMapping : mapping
              })          
        }).catch(function(err){
          console.log(err)
        })
        
      } 
     
    
    axios.get(url.getMasterListByCategory('INDUSTRY')).then(({data}) => {
      // console.log(data.data);
      this.setState({
        industriesList : sortBy(data.data[0].docs,'name')
      })
    })
    axios.get(url.getCurrentOffices(organizationId._id)).then(({data}) => {
      // console.log(data.data);
      const flat = getFlatDataFromTree({treeData : staticHierarchy,getNodeKey: ({ node }) => node.id,ignoreCollapsed: false});
      // console.log('flat---', flat)
      const localOfficePaths = flat.map((o) => ({name: o.node.title, officeKey: o.node.officeKey, path: o.path.join('#')}));
      const localOfficesWithInvitations = localOfficePaths.map((office) => {
        // console.log('p---', office)
        var oName = office.name?office.name:office.path.split('#').pop()
        return {
          officeHierarchyPath : office.path,
          officeKey: office.officeKey,
          officeName : oName,
          invitedAdmins : []
        }
      });

      // console.log(localOfficesWithInvitations)
      
      let totalOfficesWithInvitations = localOfficesWithInvitations;
      let officeWithAdminsInvited=[]

      // console.log(localOfficesWithInvitations)

      if(data.data.length > 0) {
        // console.log('data----')
        for (var x=0; x< data.data.length; x++){
          let o = data.data[x]
          // console.log(o)
          var oName = o.name?o.name: o.path.split('#').pop()

          let obj = {
            officeHierarchyPath : o.officeHierarchyPath,
            officeName : oName,
            officeKey: o.officeKey,
            invitedAdmins : o.adminList
          }
          // console.log(obj)
          officeWithAdminsInvited.push(obj)
        }
        // console.log(officeWithAdminsInvited)
        // const serverOfficesWithInvitations = data.data.map((o) => {
        //   console.log('o val --- ', o)
        //   // console.log(o.adminList);
        //   // let hpath = 
        //   let obj = {
        //     officeHierarchyPath : o.officeHierarchyPath,
        //     officeName : o.officeHierarchyPath.split('#').pop(),
        //     invitedAdmins : o.adminList
        //   }
        //   console.log('obj to ret -----',obj)
        //   return obj
        // });
        // console.log('invite -- ',officeWithAdminsInvited)
        // console.log('offices ---', localOfficesWithInvitations)
        // let allOffices = localOfficesWithInvitations.map(e => {
        //   if( officeWithAdminsInvited.indexOf(e.officeHierarchyPath){}
        // })
        totalOfficesWithInvitations = unionBy(officeWithAdminsInvited,localOfficesWithInvitations, 'officeKey');
        // allOfficesWithInvitations = officeWithAdminsInvited
        // allOfficesWithInvitations = unionBy(serverOfficesWithInvitations,localOfficesWithInvitations, 'officeHierarchyPath');
        // console.log(allOfficesWithInvitations);
      }

      console.log(totalOfficesWithInvitations)

      this.setState({
        allOfficesWithInvitations : totalOfficesWithInvitations
      })
    });
  }

  handleUserInvitationComplete = (officePath,users) => {
    const {allOfficesWithInvitations} = this.state;
    // const i = findIndex(allOfficesWithInvitations,{officeHierarchyPath : officePath});
    const i = findIndex(allOfficesWithInvitations,{officeHierarchyPath : officePath});

    const invitedOffice = {...allOfficesWithInvitations[i]};
    // console.log(invitedOffice)
    const newInvitedUsers = invitedOffice.invitedAdmins.concat(users);
    invitedOffice.invitedAdmins = newInvitedUsers;
    allOfficesWithInvitations.splice(i,1,invitedOffice);
    this.setState({
      allOfficesWithInvitations : allOfficesWithInvitations
    });
  }

  goToInviteOfficeMates = () => {
    // console.log(this.props.history)
    // this.props.history.push('/home/office/invite-office-mates');
    this.props.history.push('/home/users/invite')
}

  handleUserRemoveComplete = (officePath,userIdArray) => {
    const {allOfficesWithInvitations} = this.state;
    const i = findIndex(allOfficesWithInvitations,{officeHierarchyPath : officePath});
    // console.log(allOfficesWithInvitations[i]);
    const invitedOffice = {...allOfficesWithInvitations[i]};
    for(let i = 0 ; i < userIdArray.length ; i++) {
      const j = findIndex(invitedOffice.invitedAdmins,{_id : userIdArray[i]});
      invitedOffice.invitedAdmins.splice(j,1);
    }
    allOfficesWithInvitations.splice(i,1,invitedOffice);
    this.setState({
      allOfficesWithInvitations : allOfficesWithInvitations
    });
  }

  handleIndustryChange = (industryId) => {
    // const {organizationId} = this.props.user.profile;
    axios.put(url.updateIndustryForOrganization,{industry : industryId}).then(({data}) => {
      this.props.onIndustryChangeSuccess(industryId);
    })
  }

  handleNameChange = (newName)=>{
    axios.put(url.updateNameForOrganization,{name : newName}).then(({data}) => {
      this.props.onNameChangeSuccess(newName);
    })
  }

  handleOrgEmail=(email)=>{
    let orgId = this.props.user.profile.organizationId._id
    axios.post(url.addOrgEmailRule, {email, orgId}).then(({data}) => {
      // console.log('data----',data)
      this.props.orgChangeSuccess(email)
      // console.log("success")
    }).catch(function(err){
      console.log(err)

    })

  }

  removeOrgEmail =(email)=>{
    // console.log('email--',email)
    let orgId = this.props.user.profile.organizationId._id
    axios.post(url.removeOrgEmailRule, {email, orgId}).then(({data}) => {
      // console.log("success")
      this.props.orgEmailRemove(email)
    }).catch(function(err){
      // console.log(err)
      // this.props.orgEmailRemove(email)
      // this.props.orgChangeSuccess(email)

    })
  }
  removeOrgSlackUrl =(urls,removedId)=>{
    // console.log('email--',email)
    let orgId = this.props.user.profile.organizationId._id
    axios.post(url.removeSlackWorkspaceUrl, {url:urls, orgId,removedId}).then(({data}) => {
      // console.log("success")
      this.props.orgSlackUrlRemove(urls)
    }).catch(function(err){
      // console.log(err)
      // this.props.orgEmailRemove(email)
      // this.props.orgChangeSuccess(email)

    })
  }
  removeOrgTeamsTenant =(urls,removedId)=>{
    // console.log('email--',email)
    let orgId = this.props.user.profile.organizationId._id
    axios.post(url.removeTeamsTenantId, {url:urls, orgId,removedId}).then(({data}) => {
      // console.log("success")
      this.props.orgTenantIdRemove(urls)
    }).catch(function(err){
      // console.log(err)
      // this.props.orgEmailRemove(email)
      // this.props.orgChangeSuccess(email)

    })
  }

  handleSearchQueryChange = ({name,value}) => {
    this.setState({
      searchedTerm : value
    });
  }


  saveMapping = ()=>{
    axios.post(url.skipMapping).then(({data}) => {
      // console.log("success--", data)
    }).catch(function(err){
      console.log(err)
    })
  }

  handleSortChanged = (sort) => {
    this.setState({sortType : sort});
  }

  render() { 
    const {selectedTab,existingMapping,allOfficesWithInvitations,industriesList,searchedTerm,sortType} = this.state;
    const {organizationId, email} = this.props.user.profile;
    console.log(this.props.user.profile, "organizationId");
    // console.log(allOfficesWithInvitations);
    return ( 
      <div>
        <div className="enterpriseSettingsPageContainer container bwai-account">
          <div className="title-text">
            Account Settings

            <div className="inviteOfficeMates">
                          <div className="">
                            {
                              !isTrivvyUrl(organizationId) &&  <Button className="invite-button-bg" onClick={this.goToInviteOfficeMates}>
                              <span className="invite-button-txt">
                                  Invite </span></Button>
                            }
                             
                          </div>
                      </div>
          </div>


          {/* <div className="inviteOfficeMates">
                          <div className="">
                              <Button className="invite-button-bg" onClick={this.saveMapping}>
                                  <span className="invite-button-txt">
                                      Save Mapping </span></Button>
                          </div>
                      </div> */}
         
         
         
          
{/*          
          <div className="flex pb5 mt20" style={{borderBottom:'1px solid #D5D6D8'}}>
            <div 
              className="enterprise-tab"
              style={{color:selectedTab === 1 ? '#333333' : '#A5A6AC'}}
              onClick={() => {this.setState({selectedTab : 1})}}>
              <div>
              </div>
            </div>

            {organizationId && organizationId.isSetupSkipped?
              null
            :
            <div
            className="enterprise-tab"
            style={{color:selectedTab === 2 ? '#333333' : '#A5A6AC'}}
            onClick={() => {this.setState({selectedTab : 2})}}>
            <div>
              Manage Offices
            </div>
          </div>
            }

            
           

          </div>
          


           */}
          {/* <div>
            <div 
              className="selected-tab-underline" 
              style={{left:selectedTab === 1 ? '0px' : '180px',
                width:selectedTab === 1 ? '180px' : '180px'}}>
            </div>
          </div> */}



          {
            selectedTab === 1 ?
            <EnterpriseSettings
              existingMapping={existingMapping}
              enterpriseInformation={organizationId}
              industriesList={industriesList}
              onIndustryChange={this.handleIndustryChange}
              onNameChange={this.handleNameChange}
              handleOrgEmail={this.handleOrgEmail}
              removeOrgEmail = {this.removeOrgEmail}
              removeOrgSlackUrl={this.removeOrgSlackUrl}
              removeOrgTeamsTenant={this.removeOrgTeamsTenant}
              {...this.props}
            /> : 
            <ManageOffices
              searchedTerm={searchedTerm}
              sortType={sortType}
              allOfficesWithInvitations={allOfficesWithInvitations}
              onInvitationComplete={this.handleUserInvitationComplete}
              onRemoveUserComplete={this.handleUserRemoveComplete}
              onSearchQueryChange={this.handleSearchQueryChange}
              onSortChanged={this.handleSortChanged}
              userEmail={email}
            />
          }
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user : state.user
  }
}

const mapDispatchToProps = dispatch => {
	return {
    onIndustryChangeSuccess: (data) => dispatch(actionCreators.industryChangeSuccess(data)),
    onNameChangeSuccess: (data) => dispatch(actionCreators.enterpriseNameChange(data)),
    orgChangeSuccess: (data)=> dispatch(actionCreators.orgChangeSuccess(data)),
    orgEmailRemove: (data)=> dispatch(actionCreators.orgEmailRemove(data)),
    orgSlackUrlRemove: (data)=> dispatch(actionCreators.orgSlackUrlRemove(data)),
    orgTenantIdRemove: (data)=> dispatch(actionCreators.orgTenantIdRemove(data)),

	}
}
 
export default connect(mapStateToProps,mapDispatchToProps)(EnterpriseInformation);